import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { useAuth } from "@/hooks/use-auth";

export const Route = createFileRoute("/app/")({ component: AppIndex });

function AppIndex() {
  const { profile } = useAuth();
  const nav = useNavigate();
  useEffect(() => {
    if (!profile) return;
    if (profile.role === "staff" || profile.role === "admin") nav({ to: "/app/staff/today" });
    else nav({ to: "/app/customer/dashboard" });
  }, [profile, nav]);
  return <div className="p-6 text-sm text-muted-foreground">Redirecting…</div>;
}
